<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">危化品管理</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择状态">
            <el-option v-for="item in $store.state.badStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="危化品名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入危化品名称"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="校区">
          <el-input v-model="formInline.school_area" clearable placeholder="请输入"></el-input>

          <!-- <el-select v-model="formInline.school_area" clearable filterable placeholder="请选择校区">
            <el-option v-for="item in $store.state.params.school_area" :key="item.school_area" :label="item.school_area" :value="item.school_area"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="楼宇名称">
          <el-input v-model="formInline.building_name" clearable placeholder="请输入"></el-input>
          <!-- <el-select v-model="formInline.building_name" clearable filterable placeholder="请选择校区">
            <el-option v-for="item in $store.state.params.building_name" :key="item.building_name" :label="item.building_name" :value="item.building_name"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="地点">
          <el-input v-model="formInline.address" clearable placeholder="请输入地点"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd()">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="downloadFile">下载危化品导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <Importt :uploadSectionFile="uploadSectionFile"  @refresh="handleQuery" :action="action" :params="params" :btnTitle="btnTitle"></Importt>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :disabled="exportTitle=='导出中...'" @click="handleExportByUrl(formInline)">{{exportTitle}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed prop="name" label="危化品名称" min-width="150">
        </custom-table-column>
        <custom-table-column prop="number" label="编码" width="120">
        </custom-table-column>
        <custom-table-column prop="status" label="状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0" style="color:var(--ligtGreen);">正常</span>
            <span v-else style="color:var(--red);">废弃</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="is_borrowed" label="借用状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.is_borrowed" style="color:var(--ligtGreen);">已借用</span>
            <span v-else style="color:var(--blue);">未借用</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="structure_1" label="所属院系" min-width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" min-width="160">
        </custom-table-column>
        <custom-table-column prop="training_room" :label="`所属${$store.state.themeTitle}室`" min-width="180">
        </custom-table-column>
        <custom-table-column prop="term" label="学年学期" width="180">
        </custom-table-column>
        <custom-table-column prop="grade" label="年级" width="100">
        </custom-table-column>
        <custom-table-column prop="type2" label="类别" width="150">
        </custom-table-column>
        <custom-table-column prop="type" label="类型" width="150">
        </custom-table-column>
        <!-- <custom-table-column prop="quantity" label="数量" width="120">
        </custom-table-column>
        <custom-table-column prop="remainder_quantity" label="库存数量" width="120">
        </custom-table-column> -->
        <custom-table-column prop="price" label="价格（元）" width="150">
        </custom-table-column>
        <!-- <custom-table-column prop="total_price" label="总价" width="180">
        </custom-table-column> -->
        <custom-table-column prop="school_area" label="校区" width="180">
        </custom-table-column>
        <custom-table-column prop="building_name" label="楼宇名称" width="180">
        </custom-table-column>
        <custom-table-column prop="supplier" label="销售商" width="150">
        </custom-table-column>
        <custom-table-column prop="address" label="地点" width="150">
        </custom-table-column>
        <custom-table-column prop="manufacturer" label="制造商" width="150">
        </custom-table-column>
        <custom-table-column prop="usage" label="使用方向" width="150">
        </custom-table-column>
        <custom-table-column prop="place" label="存放地点" width="150">
        </custom-table-column>
        <custom-table-column prop="size" label="规格" width="150">
        </custom-table-column>
        <custom-table-column prop="cc_number" label="出厂编号" width="150">
        </custom-table-column>
        <custom-table-column prop="desc" label="备注" width="220">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="创建人" width="120">
        </custom-table-column>
        <custom-table-column prop="buy_at" label="购买时间" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.buy_at? $until.getTimeStr(new Date(scope.row.buy_at).getTime() / 1000,'-'):''}}</span>
          </template>
        </custom-table-column>
        <custom-table-column fixed="right" label="操作" width="190">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
            <el-button @click="handleEdit(scope.row,['building_name','is_borrowed', 'creator_id','school_area','created_at','deleted_at','address','creator_name','creator_user_name'])" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
            <el-button v-if="scope.row.status==0" @click="handleScrap(scope.row.id)" type="text" size="small">废弃</el-button>
            <el-button @click="handleUseLog(scope.row.id)" type="text" size="small">添加日志</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="706px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell" @handleOrganQuery="handleOrganQuery"></OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="编码" prop="number">
          <el-input v-model="ruleForm.number" placeholder="请输入编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="危化品名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入危化品名称" style="width:216px;"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="`所属${$store.state.themeTitle}室`" prop="training_room">
          <el-input v-model="ruleForm.training_room" :placeholder="`请输入所属${$store.state.themeTitle}室`" style="width:216px;"></el-input>
        </el-form-item> -->

        <el-form-item label="组织结构" prop="major">
          <el-input v-model="selectName" placeholder="请选择院系+专业" style="width:532px;" @focus="dialogOpen" @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="training_no">
          <el-select v-model="ruleForm.training_no" filterable style="width:216px;" :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_no"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类 别" prop="type2">
          <el-select v-model="ruleForm.type2" style="width:216px;" placeholder="请选择类别">
            <el-option v-for="item in $store.state.consumTypes" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类  型" prop="type">
          <el-input v-model="ruleForm.type" placeholder="请输入类型" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="学  期" prop="term">
          
          <el-select v-model="ruleForm.term" clearable placeholder="请选择学年学期" style="width:216px;">
            <el-option v-for="(item, index) in $store.state.termms" :key="index" :label="item.term"
              :value="item.term"></el-option>
          </el-select>
          
        </el-form-item>
        <el-form-item label="年  级" prop="grade">
          <el-select v-model="ruleForm.grade" style="width:216px;" placeholder="请选择类别">
            <el-option v-for="item in $store.state.grades" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="数  量" prop="quantity">
          <el-input v-model.number="ruleForm.quantity" placeholder="请输入数量" style="width:216px;"></el-input>
        </el-form-item> -->
        <el-form-item label="价  格" prop="price">
          <el-input v-model="ruleForm.price" placeholder="请输入价格（元）" style="width:198px;"></el-input> 元
        </el-form-item>
        <el-form-item label="购买时间" prop="buy_at">
          <el-date-picker type="datetime" placeholder="选择购买时间" value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm.buy_at" style="width:216px;"></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="总  价" prop="total_price">
          <el-input v-model="total_price" placeholder="请先输入数量和价格" :disabled="true" style="width:198px;"></el-input> 元
        </el-form-item> -->
        <el-form-item label="销售商" prop="supplier">
          <el-input v-model="ruleForm.supplier" placeholder="请输入销售商" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="制造商" prop="manufacturer">
          <el-input v-model="ruleForm.manufacturer" placeholder="请输入制造商" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="使用方向" prop="usage">
          <el-input v-model="ruleForm.usage" placeholder="请输入使用方向" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="存放地点" prop="place">
          <el-input v-model="ruleForm.place" placeholder="请输入存放地点" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="规  格" prop="size">
          <el-input v-model="ruleForm.size" placeholder="请输入规格" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="出厂编号" prop="cc_number">
          <el-input v-model="ruleForm.cc_number" placeholder="请输入出厂编号" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="desc">
          <el-input type="textarea" v-model="ruleForm.desc" placeholder="请输入备注" style="width:532px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" v-if="type=='add'" @click="submitForm('ruleForm')">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitForm('ruleForm')">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="废弃" :visible.sync="numberDialogVisible" width="406px">
      <el-form :model="ruleForm1" :rules="rules1" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
        <el-form-item label="废弃日期" prop="scrap_date">
          <el-date-picker type="datetime" placeholder="选择废弃日期" value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm1.scrap_date" style="width:242px;"></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm1',changeScrapStatus)">确认</el-button>
          <el-button @click="resetForm('ruleForm1')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="添加使用日志" :visible.sync="numberDialogVisible1" width="406px">
      <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
        <el-form-item label="使用日期" prop="use_at">
          <el-date-picker type="datetime" placeholder="选择使用日期" value-format="yyyy-MM-dd HH:mm:ss" v-model="ruleForm2.use_at" style="width:242px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="用途" prop="usage">
          <el-input type="textarea" v-model="ruleForm2.usage" placeholder="请输入备注" style="width:242px;" :rows="4"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm2',addUseLog)">确认</el-button>
          <el-button @click="resetForm('ruleForm2')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteTarinRoom">确 定</el-button>
      </span>
    </el-dialog>
    <OrganDialog ref="organDia"></OrganDialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinImport } from '@/assets/js/mixin/import';
import { mixinValidate } from '@/assets/js/mixin/validate';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan, mixinImport, mixinValidate],
  data() {
    return {
      formInline: {
        name: '',
        training_room: '',
        building_name: '',
        school_area: '',
        address: '',
        structure_1: '',
        major: '',
        status: '',
      },
      selectName: '',
      organLabel: '',
      levell: [1, 2],
      ruleForm: {
        number: '',
        name: '',
        training_room: '',
        training_no: '',
        price: 0,
        buy_at: '',
        supplier: '',
        manufacturer: '',
        type: '',
        usage: '',
        place: '',
        size: '',
        cc_number: '',
        desc: '',
        structure_1: '',
        major: '',
        type2: '',
        term: '',
        grade: '',
      },
      ruleForm1: {
        id: '',
        scrap_date: '',
      },
      numberDialogVisible: false,
      classRooms: [],
      rules: {
        number: [{ required: true, message: '请输入编号', trigger: 'blur' }],
        type2: [{ required: true, message: '请选择类别', trigger: 'change' }],
        term: [{ required: true, message: '请选择学年学期', trigger: 'change' }],
        grade: [{ required: true, message: '请选择年级', trigger: 'change' }],
        major: [{ required: true, message: '请选择院系+专业' }],
        price: [
          { required: true, message: '价格不能为空', trigger: 'blur' },
          { validator: this.checkfloat, trigger: 'blur' },
        ],
        name: [{ required: true, message: '请输入危化品名称', trigger: 'blur' }],
        // training_room: [{ required: true, message: `请输入所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
        training_no: [{ required: true, message: `请选择所属${this.$store.state.themeTitle}室`, trigger: 'change' }],
        buy_at: [{ required: true, message: '请选择购买时间', trigger: 'change' }],
      },
      rules1: {
        scrap_date: [{ required: true, message: '请选择废弃时间', trigger: 'change' }],
      },
      numberDialogVisible1: false,
      ruleForm2: {
        goods_id: '',
        use_at: '',
        usage: '',
      },
      rules2: {
        use_at: [{ required: true, message: '请选择废弃时间', trigger: 'change' }],
        usage: [{ required: true, message: '请输入用途', trigger: 'blur' }],
      },
      action: '',
      downloadUrl: 'template/危险品及有毒物品导入模版.xlsx',
      downloadName: '危化品导入模版.xlsx',
      btnTitle: '导入危化品数据',
      exportUrl: '',
    };
  },
  created() {
    this.action = `${this.baseUrlt}api/danger_goods/import`;
    this.exportUrl = `${this.baseUrlt}api/consume/queryExport`;
    this.$store.dispatch('getTermms');
    this.$store.dispatch('getTarinMent');
    // this.$store.dispatch('getParams');
  },
  computed: {
    total_price() {
      // this.total_price = this.quantity*this.price
      return (this.ruleForm.quantity * this.ruleForm.price * 1000) / 1000;
    },
  },
  mounted() {},
  methods: {
    handleScrap(id) {
      this.numberDialogVisible = true;
      this.ruleForm1.id = id;
    },
    handleUseLog(id) {
      this.numberDialogVisible1 = true;
      this.ruleForm2.goods_id = id;
    },
    async addUseLog() {
      let params = this.$until.easyDeepCopy(this.ruleForm);2;
      let res = await this.$api.instance.interfaceServer(`api/danger_goods/records/add`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '日志添加成功！',
        });
        this.ruleForm2 = {
          goods_id: '',
          use_at: '',
          usage: '',
        };
        this.numberDialogVisible1 = false;
        this.handleQuery();
      }
    },
    async changeScrapStatus() {
      let params = this.$until.easyDeepCopy(this.ruleForm);1;
      let res = await this.$api.instance.interfaceServer(`api/danger_goods/scrap`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '状态修改成功！',
        });
        this.ruleForm1 = {
          id: '',
          scrap_date: '',
        };
        this.numberDialogVisible = false;
        this.handleQuery();
      }
    },
    handleQuery() {
      this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    getOrganList() {
      this.beforeGetOrgan();
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.training_room = this.$until.getLabelName(this.$store.state.trainRooms, 'training_no', 'training_name', e);
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    async deleteTarinRoom() {
      // let params = { id: this.delid };
      let res = await this.$api.instance.interfaceServer(`api/danger_goods/delete/${this.delid}`, 'delete');
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createTarinRoom() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.instance.interfaceServer('api/danger_goods/createUpdate', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateTarinRoom() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.instance.interfaceServer('api/danger_goods/createUpdate', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/danger_goods/query', 'post', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at', 'login_time']) {
      if (row.structure_1 && row.major) {
        this.selectName = `${row.structure_1}-${row.major}`;
      }
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.type == 'add') {
            this.createTarinRoom();
          } else if (this.type == 'edit') {
            this.updateTarinRoom();
          }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
